import { BaseService } from "./BaseService";

export class VipService extends BaseService {
  getReports() {
    return this.request("api/Vip/GetReports/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  hasReports() {
    return this.request("api/Vip/HasReports/", {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }

  getReportPdf(pdf) {
    return this.request(pdf, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    });
  }
}

const vipService = new VipService();

export default vipService;
